module.exports = __webpack_public_path__ + "18b5247c3a528d7d9e68cf8319122f7f.png";